import { createSlice } from '@reduxjs/toolkit';

enum ACCOUNT_STATUS {
  FREEMIUM = 'freemium',
  PAID = 'paid',
  UNAUTHORIZED = 'unauthorized'
}

export interface Features {
  oneTimeMeeting: boolean;
}

export interface Settings {
  requireMeetingPasscode: boolean;
}

export interface Account {
  status: string;
  features: Features;
  settings: Settings;
}

export interface Session {
  extension: string;
  email: string;
  displayName: string;
  uuid: string;
}
export interface CheckInState {
  session: Session;
  account: Account;
}

const initialState: CheckInState = {
  session: {
    extension: '',
    email: '',
    displayName: '',
    uuid: ''
  },
  account: {
    status: '',
    features: {} as Features,
    settings: {} as Settings
  }
};

const checkInSlice = createSlice({
  name: 'checkin',
  initialState,
  reducers: {
    setCheckIn(state, action) {
      return action.payload;
    },
    resetCheckIn() {
      return initialState;
    },
    updateAccountStatus(state, action) {
      state.account.status = action.payload;
    }
  }
});

export { ACCOUNT_STATUS };
export const { setCheckIn, resetCheckIn, updateAccountStatus } = checkInSlice.actions;
export default checkInSlice.reducer;
